import DrawerHeader from "ds/components/Drawer/Header";
import DrawerBody from "ds/components/Drawer/Body";
import Typography from "ds/components/Typography";
import DrawerHeaderTitle from "ds/components/DrawerNew/HeaderTitle";
import DrawerCloseIcon from "ds/components/DrawerNew/CloseIcon";
import DrawerFooter from "ds/components/Drawer/Footer";
import DocumentationButton from "components/DocumentationButton";
import { getDocsUrl } from "utils/getDocsUrl";
import { AnalyticsPageOrganization } from "hooks/useAnalytics/pages/organization";

import styles from "./styles.module.css";

const RoleInfoDrawerContent = () => {
  return (
    <>
      <DrawerHeader justify="between">
        <DrawerHeaderTitle title="Permissions" />
        <DrawerCloseIcon />
      </DrawerHeader>
      <DrawerBody>
        <Typography tag="p" variant="p-body2" className={styles.description}>
          Each entity in Spacelift supports a specific set of actions. These actions are represented
          as permissions, which can be combined to create custom roles for managing access.
        </Typography>
        <DrawerFooter>
          <DocumentationButton
            to={getDocsUrl(
              "/concepts/authorization/rbac-system#actions-the-building-blocks-of-permissions"
            )}
            analyticsPage={AnalyticsPageOrganization.OrganizationRole}
          />
        </DrawerFooter>
      </DrawerBody>
    </>
  );
};

export default RoleInfoDrawerContent;
